import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import News from '@/components/News'
//import PromotionBannerTerms from '@/components/PromotionBannerTerms'
//import GoldenSmileBannerTerms from '@/components/GoldenSmileBannerTerms'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/news',
      name: 'News',
      component: News
    }/*,
    {
      path: '/win-a-car-ts-and-cs',
      name: 'PromotionBannerTerms',
      component: PromotionBannerTerms
    },
    {
      path: '/golden-smile-ts-and-cs',
      name: 'GoldenSmileBannerTerms',
      component: GoldenSmileBannerTerms
    }*/
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js